import router from "../router/index.js";

/**
 * go to page
 * @param name page name
 * @param params params
 */
export function goTo(options, refresh = false) {
  const path = typeof options === "string" ? { name: options } : options;
  // router.push(path)
  if (refresh) {
    router.go(path);
  } else {
    router.push(path);
  }
}
/**
 * open a new window
 * @param url
 */
export function openNewWindow(url) {
  window.open(url, "_blank");
}
/**
 * go back
 */
export function goBack(path) {
  if (!path || path.toString() === "[object PointerEvent]") {
    window.history.go(-1);
  } else {
    router.push(path);
  }
}
/**
 * render template
 * @param template string template
 * @param context data
 */
export function renderTemplate(template, context) {
  return template.replace(/\{%(.*?)%\}/g, (match, key) => {
    const keys = key.split(".");
    if (keys.length > 1) {
      return context[keys[0].trim()][keys[1].trim()] || "";
    } else {
      return context[keys[0].trim()] || "";
    }
  });
}

export function renderDict(dict, field, attr) {
  return dict[`${field}`]?.[attr] || dict.default?.[attr] || "";
}

/**
 * id补位
 */
export function idFix(num, length) {
  return String(num).padStart(length, "0").slice(-length);
}

export function getScrollContainer() {
  return (
    document.querySelector(".main-area") ||
    document.querySelector(".container") ||
    document.querySelector(".search-container")
  );
}

/**
 * 回到顶部
 */
export function backToTop() {
  const container = getScrollContainer();
  if (container) {
    container.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

/**
 * 收集参数
 */
export function getParams(query) {
  return Object.fromEntries(
    Object.entries(query).filter(
      ([key, value]) =>
        key === "page" || key === "page_size" || ![null, "", undefined].includes(value)
    )
  );
}
/**
 * 小数点位数格式化
 */
export function keepTwo(number) {
  return Number(Number(number).toFixed(2));
}

/** 与结算逻辑一致：有 charge_duration_hours 用手动小时，否则按分钟/60 */
export function effectiveChargeHoursFromRecord(record) {
  if (!record) return 0;
  const hasOverride = record.charge_duration_hours != null && record.charge_duration_hours !== "";
  if (hasOverride) {
    return Number(record.charge_duration_hours) || 0;
  }
  return (Number(record.charge_duration) || 0) / 60;
}

/** 与结算逻辑一致：有 charge_total_hours 用手动总小时，否则按收费小时 * 倍率 */
export function effectiveChargeTotalHoursFromRecord(record) {
  if (!record) return 0;
  const hasOverride = record.charge_total_hours != null && record.charge_total_hours !== "";
  if (hasOverride) {
    return Number(record.charge_total_hours) || 0;
  }
  return effectiveChargeHoursFromRecord(record) * (Number(record.expert_rate) || 0);
}

/** 单行任务：分钟 + 对应小时 */
export function formatChargeDurationMinAndHours(record) {
  const mins = Number(record && record.charge_duration) || 0;
  const h = effectiveChargeHoursFromRecord(record);
  return `${mins} 分钟 / ${keepTwo(h)} 小时`;
}

/** 仅汇总分钟数（如项目总收费分钟） */
export function formatChargeDurationMinutesTotal(totalMinutes) {
  const m = Number(totalMinutes) || 0;
  return `${m} 分钟 / ${keepTwo(m / 60)} 小时`;
}

/**
 * 提取sort_by
 */
export function getSortBy(data) {
  if (data && data.field && data.order) {
    if (data.order === "descend") {
      return `-${data.field}`;
    } else {
      return data.field;
    }
  } else {
    return "";
  }
}

// 通用币种映射表（key：币种代码，value：币种符号/格式）
